import React from 'react'
import {Button, Panel} from 'react-bootstrap'

export default class DataPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true
    };
  }

  generateErrorOrWarning() {
    const elements = [
      'game_updated',
      'addon_updated',
      'game_price_updated',
      'addon_price_updated',
      'game_timestamp_updated'
    ]
    const res = {}
    elements.forEach(ele => (res[ele] = (this._getKlassName(ele) || 'default')))
    return res
  }

  _getKlassName(ele) {
    const data = this.props.data;
    switch(ele) {
      case 'game_updated':
        if(data.games.delay>12) {
          return 'danger'
        }else if(data.games.delay>6) {
          return 'warning'
        }else {
          return
        }
      case 'addon_updated':
        if(data.addons.delay>10) {
          return 'danger'
        }else if(data.addons.delay>4) {
          return 'warning'
        }else {
          return
        }
      case 'game_price_updated':
        if(data.game_prices.delay>10) {
          return 'danger'
        }else if(data.game_prices.delay>4) {
          return 'warning'
        }else {
          return
        }
      case 'addon_price_updated':
        if(data.addon_prices.delay>10) {
          return 'danger'
        }else if(data.addon_prices.delay>4) {
          return 'warning'
        }else {
          return
        }
      case 'game_timestamp_updated':
        if(data.game_timestamps.delay>10) {
          return 'danger'
        }else if(data.game_timestamps.delay>4) {
          return 'warning'
        }else {
          return
        }
      default:
        return;
    }
  }

  _getPanelKlassName(errorOrWarning) {
    let values = Object.values(errorOrWarning)
    if(values.includes('danger')) {
      return 'danger'
    }else if(values.includes('warning')) {
      return 'warning'
    }else {
      ''
    }
  }

  render() {
    const data = this.props.data;
    const errorOrWarning = this.generateErrorOrWarning();
    const panelKlassName = this._getPanelKlassName(errorOrWarning);

    return (
      <div className='DataPanel'>
        <Panel id="collapsible-panel-example-2" defaultExpanded={this.state.open} bsStyle={panelKlassName}>
          <Panel.Heading>
            <Panel.Title toggle>
              MONITORING DATA
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <h6 className='title'>GAMES</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.game_updated}`}>
                  Last updated Game :
                </dt>
                <dd className={`text-${errorOrWarning.game_updated}`}>{data.games.last_updated}</dd>
                <dt className={`text-${errorOrWarning.game_price_updated}`}>
                  Price updated At :
                </dt>
                <dd className={`text-${errorOrWarning.game_price_updated}`}>{data.game_prices.last_updated}</dd>
                <dt className={`text-${errorOrWarning.game_timestamp_updated}`}>
                  Last updated Release Timestamp :
                </dt>
                <dd className={`text-${errorOrWarning.game_timestamp_updated}`}>{data.game_timestamps.last_updated}</dd>
              </dl>
              <hr/>
              <h6 className='title'>ADDONS</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.addon_updated}`}>
                  Last updated Addon :
                </dt>
                <dd className={`text-${errorOrWarning.addon_updated}`}>{data.addons.last_updated}</dd>
                <dt className={`text-${errorOrWarning.addon_price_updated}`}>
                  Price updated At :
                </dt>
                <dd className={`text-${errorOrWarning.addon_price_updated}`}>{data.addon_prices.last_updated}</dd>
              </dl>

            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Dataquest/DataPanel.jsx